// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info p[data-v-1fe16226]{display:inline-block;font-size:14px}.info p.link[data-v-1fe16226]{color:#2680eb;cursor:pointer}.info .account-settings__submit[data-v-1fe16226]{margin-top:0!important;font-size:12px}", ""]);
// Exports
module.exports = exports;
